import { useCallback } from "react";

export const RECAPTCHA_STYLE = `.grecaptcha-badge { visibility: hidden; }`;

type UseRecaptchaStyleHandler = () => () => void;

export const useRecaptchaStyleHandler: UseRecaptchaStyleHandler = () => {
  return useCallback(() => {
    const grecaptchaStyle = document.getElementsByClassName("grecaptcha-badge");
    if (grecaptchaStyle.length > 0) return;

    const head = document.head;
    const style = document.createElement("style");
    style.appendChild(document.createTextNode(RECAPTCHA_STYLE));
    head.appendChild(style);
  }, []);
};
